import { render } from "./CompareToDonorComponent.vue?vue&type=template&id=18107810&scoped=true"
import script from "./CompareToDonorComponent.vue?vue&type=script&lang=js"
export * from "./CompareToDonorComponent.vue?vue&type=script&lang=js"

import "./CompareToDonorComponent.vue?vue&type=style&index=0&id=18107810&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18107810"]])

export default __exports__